import { render, staticRenderFns } from "./BasketBanner.vue?vue&type=template&id=0d4148e6&scoped=true"
import script from "./BasketBanner.vue?vue&type=script&lang=js"
export * from "./BasketBanner.vue?vue&type=script&lang=js"
import style0 from "./BasketBanner.vue?vue&type=style&index=0&id=0d4148e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4148e6",
  null
  
)

export default component.exports